import { getStore } from '../../../../design3/asset-build/js/custom/stores';
import { autorun } from 'mobx';

export default async function initProductPages() {
	// this handles removing this server side table component on the detail page and the cards on the landing page
	if (window.FS?.productId || window.FS?.productCategories?.length) {
		const productAvailabilityStore = await getStore('productAvailabilityStore');

		// detail page
		autorun(
			async () => {
				// hide static if we're on a single product page OR we've finished fetching and there are products
				const hideStatic =
					window.FS?.productId ||
					(!window.FS?.productId &&
						!productAvailabilityStore.fetching &&
						productAvailabilityStore.allProducts.length > 0);
				if (hideStatic) {
					document.querySelector('html').classList.add('HideSelectStatic');
				} else {
					document.querySelector('html').classList.remove('HideSelectStatic');
				}

				//delay looking for te play availability for half a second so react has time to render
				let numOfRuns = 0;
				const internvalId = setInterval(() => {
					numOfRuns += 1;

					if (numOfRuns < 10) {
						const signatureReactApps =
							document.querySelectorAll('.ProductSignatureCardDetails-react-ssr-placeholder') || [];

						signatureReactApps.forEach(element => {
							const availMessage = element.querySelector('.SignatureCard-availMessage');
							if (availMessage) {
								const videoPlayButton = element.parentElement.querySelector('.Video-playButton');
								videoPlayButton?.classList?.remove('Video-playButton');
								videoPlayButton?.classList?.add('Video-playButton--hasAvailabilityMessage');
							}
						});
					} else {
						clearInterval(internvalId);
					}
				}, 500);

				if (window.FS?.productId) {
					$(
						'.ProductDetailPage .grid-img-container .Gallery-button, ' +
							'.ProductDetailPage .image-addtocart-signature .fullscreen-image,' +
							'.ProductDetailPage .image-addtocart-signature .open-gallery,' +
							'.ProductDetailPage .Gallery-Signature-button'
					).on('click', event => {
						event.stopPropagation();
						const slideIndex = parseInt(event.currentTarget.dataset.slideIndex);
						window.dispatchEvent(
							new CustomEvent('openGalleryOverlay', {
								detail: {
									id: 'product-detail-gallery',
									slideIndex: isNaN(slideIndex) ? 0 : slideIndex,
								},
							})
						);
					});
				}
			},
			{
				onError: error => {
					//shouldn't error but just in case we want to show the accomodations
					document.querySelector('html').classList.remove('HideSelectStatic');
				},
			}
		);
	}
}
